import { Context, useContext } from 'react';

import { TripContext } from './trip.context';
import { TripContextType } from './types';

export const useTrip = () => {
  return useContext(TripContext as Context<TripContextType>) ?? {};
};
